export enum RefundType {
  StoreCredit = 'StoreCredit',
  PaymentRefund = 'PaymentRefund',
  CustomCode = 'CustomCode',
}
